<template>
  <heade>
  <nav  class="navbar navbar-expand-lg navbar-dark bg-dark">

    <a  class="linked navbar-brand" v-if="isLogin" href="/#/dashboard">Kichwa Code</a>
    <a  class="linked navbar-brand" v-else href="/">Kichwa Code</a>

    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav mr-auto">

        <a class="nav-link" href="https://github.com/CaosEducationPersonalProyects">
          Caospierre
          <span class="sr-only"></span>
        </a>
      </ul>

    </div>
    <div class="nav-toggler logout" @click="toggleNav()">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>

    </div>
  </nav>

    <div class="list-group"
         v-if="isActive"
         v-bind:class="{ navActive: isActive }">

      <a href="#/dashboard" class="list-group-item list-group-item-action" v-if="isLogin" >Mi Panel</a>
      <a href="#/profile" class="list-group-item list-group-item-action" v-if="isLogin" >Mi Perfil</a>
      <a href="#/quiz" class="list-group-item list-group-item-action disabled"  v-if="isLogin" >Mis Certificados</a>

      <a href="#/quiz" class="list-group-item list-group-item-action" v-if="isLogin" >Encuesta</a>
      <a href="#/logout" class="list-group-item list-group-item-action "  v-if="isLogin" >Cerrar Sesíon</a>
      <a href="/" class="list-group-item list-group-item-action" v-if="!isLogin" >Inicio</a>
      <a  href="/" v-on:click="logout()" class="list-group-item list-group-item-action" v-if="!isLogin" >Danos tu comentario</a>


    </div>
  </heade>
</template>

<script>
import store from "@/store";

export default {
  name: 'Navbar',
  data() {
    return {
      isActive: false,
      userLogin:{},
      isLogin:false
    };
  },
  methods: {
    toggleNav() {
      this.isActive = !this.isActive;
    },
    clicked: function (path) {
      this.$router.push(path)
    },
    logout: function (){

      this.$router.push('/login');

    },
    getUserLogin: function (){
      this.userLogin =  JSON.parse(store.getters.getJWT);
      this.isLogin = store.getters.isLogin;

    }
  },
  created: function(){
    this.getUserLogin();
  }

}
</script>

<style>
.linked{
  margin-left: 5px;
}
.logout{
  position: absolute;
  top: 8px;
  right: 16px;
}

.bar1{
  background-color: #dddddd;}
.bar2{
  background-color: #dddddd;}
.bar3{
  background-color: #dddddd;}

</style>
